import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import BreadcrumbRenderer from '../../breadcrumb-renderer/index.tsx';

export type Props = {
	targetElement: HTMLElement;
};

const LOCATION = 'breadcrumbs.legacy-adapter.legacy-renderer';

export default class LegacyBreadcrumbRenderer extends Component<Props> {
	componentDidCatch(error: Error) {
		/*
            This error boundary is added to adapt to a runtime error caused by createPortal method in IE 11
        */
		const { targetElement } = this.props;
		const targetId = targetElement ? targetElement.id : 'not-found';
		log.safeErrorWithoutCustomerData(LOCATION, `Failed to createPortal on ${targetId}`, error);
	}

	render() {
		const { targetElement } = this.props;
		return createPortal(<BreadcrumbRenderer />, targetElement);
	}
}
